/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './Dropdown.scss'
import React from 'react'
import Select from 'react-select'
import { List } from 'immutable'

function Dropdown(props) {
  const className = props.className || 'Dropdown--default'
  const raised = props.raised ? 'Dropdown--raised' : ''
  const classNamePrefix = props.classNamePrefix || 'select'
  const placeholder = props.placeholder || 'Please Select'
  const isDisabled = props.isDisabled || false
  const isLoading = props.isLoading || false
  const isClearable = props.isClearable || false
  const isMulti = props.isMulti || false
  const searchable = props.searchable || false
  const disabled = props.disabled || false
  const onChange = props.onChange || (() => {})

  let options = Array.isArray(props.options) ? props.options : null
  if (!options && List.isList(props.options)) {
    options = props.options.toArray().map(it => it.toObject())
  }

  const handleChange = selectedOption => {
    if (selectedOption) {
      const value = Array.isArray(selectedOption) ? selectedOption.map(o => o.value) : selectedOption.value
      const dummyEvent = { target: { name: props.name, value: value } }
      onChange(dummyEvent)
    }
  }

  const value = props.value !== null ? props.value : null
  let values = null
  if (value !== null) {
    if (Array.isArray(value) || List.isList(value)) {
      values = options.filter(o => value.findIndex(v => String(v) === String(o.value)) !== -1)
    } else {
      values = options.filter(option => String(option.value) === String(value))
    }
  }

  return (
    <Select
      className={`Dropdown ${className} ${raised}`}
      classNamePrefix={classNamePrefix}
      placeholder={placeholder}
      defaultValue={props.defaultValue}
      value={values}
      isDisabled={isDisabled}
      isLoading={isLoading}
      isClearable={isClearable}
      isMulti={isMulti}
      isSearchable={searchable}
      name={props.name}
      options={options}
      onChange={handleChange}
      isDisabled={disabled}
    />
  )
}

export default Dropdown
